import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-tariff-details',
    templateUrl: './tariff-details.component.html',
    styleUrls: ['./tariff-details.component.scss'],
    imports: [NgClass, TranslatePipe]
})
export class TariffDetailsComponent {

    public readonly details = input<any>(undefined);
    public visible = false;

    close() {
        this.visible = false;
    }

    open() {
        this.visible = true;
    }
}
